<template>
  <div>
    <div @click="dialogVisible = true">
      <slot></slot>
    </div>
    <el-dialog
      v-loading="loading"
      title="Добавить новую зону"
      :visible.sync="dialogVisible"
    >
      <el-form>
        <el-form-item label="Название зоны">
          <el-input v-model="form.name" placeholder/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">Отменить</el-button>
      <el-button type="primary" @click="save">Добавить</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'AddDir',
  props: ['parentId'],
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {name: ''},
    };
  },

  methods: {
    fire() {
      return myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    save() {
      let form = this.form;
      if (this.parentId) {
        form.parentId = this.parentId;
      }
      this.fire()
        .collection('zones')
        .add({
          ...form,
        }).then((add) => {
        this.$emit('update');
        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'Новая зона добавлена',
          type: 'success',
        });
        this.$emit('new-object', {
          id: add.id,
          parentId: this.parentId,
          ...this.form,
        });
        this.dialogVisible = false;
        this.form = {
          name: '',
        };
      }).catch((error) => {
        console.error(error);
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Dashboard/Inputs/Zone/components/AddDir.vue